import { render } from "./BoardJamye.vue?vue&type=template&id=3743a28b"
import script from "./BoardJamye.vue?vue&type=script&lang=js"
export * from "./BoardJamye.vue?vue&type=script&lang=js"

import "./BoardJamye.vue?vue&type=style&index=0&id=3743a28b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__